export const GET_HANDOVER_INITIATED = 'GET_HANDOVER_INITIATED';
export const GET_HANDOVER_SUCCESS = 'GET_HANDOVER_SUCCESS';
export const GET_HANDOVER_FAILURE = 'GET_HANDOVER_FAILURE';
export const GET_HANDOVER_TEMP_CLEAR = 'GET_HANDOVER_TEMP_CLEAR';
